
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MasterService } from '../../Shared/app.Masters.Service';
import { RequestModel } from '../../Shared/Models/app.MasterRequestModel';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
declare var $: any;

@Component({
  selector: 'app-voucher-trail',
  templateUrl: './voucher-trail.component.html',
  styleUrls: ['./voucher-trail.component.scss']
})

export class VoucherTrailComponent implements OnInit {
  showSpinner: boolean = false;
  displayedLoanColumns: string[] = ['Type', 'CaseNo', 'Customer', 'Branch', 'Category', 'AccountHead', 'AmountDR', 'AmountCR'];
  displayedAccountingColumns: string[] = ['AccountHead', 'Branch', 'AmountDR', 'AmountCR']
  Search: any = {
    VoucherDateFrom: '', VoucherDateTo: '', PostDateFrom: '', PostDateTo: '', SelectEmployee: 0, VoucherType: "", VoucherSubType: "", Type: 0, chhead: 0
  };
  AccountControl = new UntypedFormControl();
  filteredAccountHead: Observable<any[]>;
  AccountHeadDropdown: any[] = [];
  AccountHead: any;
  AccountAddress: any;
  AccountHeadName: any;
  loading: boolean = false;
  EmployeeList: any;
  FyearId: any;
  maxDate: any;
  JsonData: any[] = [];
  minDate: any;
  accountTagDropdown: any[] = [];
  dataSource: any;
  displayedColumnsModel: string[] = [];
  voucherModel: any = { Voucher: { Voucher_Detail: [] }, Voucher_Detail: [] };
  voucherEditModel: any = { Voucher: [], Voucher_Detail: [] };
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatPaginator, { read: MatPaginator }) set matPaginator(paginator: MatPaginator) {
    if (paginator != undefined) {
      this.dataSource.paginator = paginator;
    }
  }
  configSuccess: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'right',
    verticalPosition: 'top',
    panelClass: 'style-success'
  };

  constructor(private dataSharingService: DataSharingService,private lmsService: LmsService, private route: ActivatedRoute, private MasterService: MasterService, private snackBar: MatSnackBar) { }
  RequestModel: RequestModel = new RequestModel();
  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Voucher Trail");
    this.route.queryParams.subscribe(
      params => {
        this.FyearId = params['fyear'];
        //console.log("paran", this.FyearId);
        this.lmsService.Get_FinancialYear({ Id: this.FyearId }).subscribe((res: any) => {
          this.minDate = new Date(moment(res[0].fystart).format('MM/DD/YYYY'));
          this.maxDate = new Date(moment(res[0].fyent).format('MM/DD/YYYY'));
          this.Search.VoucherDateFrom = new Date(moment(res[0].fystart).format('MM/DD/YYYY'));
          if (this.maxDate > new Date() && this.minDate < new Date())
            this.Search.VoucherDateTo = new Date();
          else
            this.Search.VoucherDateTo = this.maxDate;
          this.dataSource = null;
        });
      }
    )
    this.GetEmployee();
    this.getAccounthead();
  }
  GetEmployee() {
    this.RequestModel.BranchId =0;
    this.RequestModel.RoleId = 0;
    this.MasterService.GetEmployeeList(this.RequestModel).subscribe((res: any) => {

      this.EmployeeList = res;
    //  this.Get_PartnerForDropdown();
    })
  }
    getAccounthead() {
      this.lmsService.Get_Account_Master({}).subscribe((res: any) => {
        this.AccountHeadDropdown = res;
  
        //for (var i = 0; i < res.length; i++) {
        //  this.chargesHeadDropdown.push({ id: res[i]["AccountId"], name: res[i]["Account_Name"]});
        //}
        this.filteredAccountHead = this.AccountControl.valueChanges.pipe(
          startWith(""),
          map((value) =>
            typeof value === "string" ? value : value.Account_Name
          ),
          map((name) =>
            name ? this._filter(name) : this.AccountHeadDropdown.slice()
          )
        );
      });
    }
    onAccountHeadhSelect(event: any) {
    this.AccountHead = event.option.value.AccountId;
    this.AccountHeadName = event.option.value.Account_Name;
    this.AccountAddress = event.option.value.Acc_Address;
  }
  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.AccountHeadDropdown.filter(
      (option) => option.Account_Name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  displayFn(account: any): string {
    return account && account.Account_Name ? account.Account_Name : "";
  }
  onSearchTrailVoucher() {
    this.showSpinner = true;
    var type = "CREATE";
    var VoucherSubType = "";
    var VoucherType = "";
    if (this.Search.Type == 0)
      type = "CREATE";
    if (this.Search.Type == 1)
      type = "DELETE";
    if (this.Search.Type == 2)
      type = "EDIT";
    if (this.Search.VoucherSubType == 1)
      VoucherSubType = "Loan";
    if (this.Search.VoucherSubType == 2)
      VoucherSubType = "Accounting";
    if(this.Search.VoucherSubType == 3)
      VoucherSubType = "Partner";

    if (this.Search.VoucherType == 1)
      VoucherType = "Receipt";
    if (this.Search.VoucherType == 2)
      VoucherType = "Payment";
    if (this.Search.VoucherType == 3)
      VoucherType = "Journal";
    if (this.Search.VoucherType == 4)
      VoucherType = "Contra";
    if (this.Search.VoucherType == 5)
      VoucherType = "Disbursement";
    if (this.Search.VoucherType == 6)
      VoucherType = "Repayment";

    if (this.Search.Type == 1  )
      this.displayedColumnsModel = [
        "VoucherId", "VoucherDate", "Voucher_No", "Voucher_CreateBy", "Voucher_CreateOn", "Voucher_DeleteBy", "Voucher_DeleteOn", "Voucher_Type", "Voucher_Sub_Type", "ViewAction"];
    else if (this.Search.Type == 2) {
      this.displayedColumnsModel = [
        "VoucherId", "VoucherDate", "Voucher_No", "Voucher_CreateBy", "Voucher_CreateOn", "Voucher_ModifyBy", "Voucher_ModifyOn", "Voucher_Type", "Voucher_Sub_Type", "ViewAction"];

    }
    else
      this.displayedColumnsModel = [
        "VoucherId", "VoucherDate", "Voucher_No", "Voucher_CreateBy", "Voucher_CreateOn", "Voucher_Type", "Voucher_Sub_Type", "ViewAction"];


    this.lmsService.ACC_Voucher_Trail({
      From: this.Search.VoucherDateFrom, To: this.Search.VoucherDateTo, PostFrom: this.Search.PostDateFrom,
      PostTo: this.Search.PostDateTo, EmpId: this.Search.SelectEmployee.toString(),
      VoucherType: VoucherType, VoucherSubType: VoucherSubType, Type: type, CaseNo: this.Search.LoanApplicationNo, AccountId : Number(this.Search.chhead.AccountId == null ? 0 : this.Search.chhead.AccountId),
    }).subscribe((res: any) => {
      if (res.length > 0) {
        this.JsonData = JSON.parse(JSON.stringify(res));
        

        this.dataSource = new MatTableDataSource(JSON.parse(JSON.stringify(res)));

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
      else {
        this.dataSource = null;
        this.snackBar.openFromComponent(SnackbarComponent, { data: "No Data Found", ...this.configSuccess });
      }
      this.showSpinner = false;
    });
  }

  DateChange() {
    //if (this.Search.VoucherDateFrom > this.VoucherDateTo) {
    //  this.snackBar.openFromComponent(SnackbarComponent, { data: "VoucherDate To greater than VoucherDate From.", ...this.configSuccess });
    //  this.lmsService.Get_FinancialYear({ Id: this.FyearId }).subscribe((res: any) => {

    //    this.Search.VoucherDateFrom = new Date(moment(res[0].fystart).format('MM/DD/YYYY'));
    //    this.Search.VoucherDateTo = new Date();
    //  });
    //}
  }
  OnCloseVoucherDetail() {
    $('#VoucherDetail').modal('hide');
  }
  OnCloseVoucherEditDetail() {
    $('#VoucherEditDetail').modal('hide');

  }
  goToDetail(row) {
    if (this.Search.Type == 0) {
      this.lmsService
        .LMS_Get_Voucher_Details({ VoucherId: row.VoucherId })
        .subscribe((res: any) => {
          //console.log("res", res);
          this.voucherModel.Voucher = res.Item1[0];
          this.voucherModel.Voucher_Detail = res.Item2;

          this.voucherModel.Voucher_Detail.forEach(x => {
            x.AmountDR = 0.00;
            x.AmountCR = 0.00;
            if (x.TranType == 'CR')
              x.AmountCR = x.Amount;
            if (x.TranType == 'DR')
              x.AmountDR = x.Amount;
          });
          if (this.voucherModel.Voucher.Voucher_Mode_of_Payment == '' || this.voucherModel.Voucher.Voucher_Mode_of_Payment == null)
            this.voucherModel.Voucher.Voucher_Mode_of_Payment = '';
          this.onVoucherTagChange();
          $('#VoucherDetail').modal('show');
          $("#VoucherDetail").css("z-index", "1050");
        });
    }
    else if (this.Search.Type == 1) {
  this.lmsService
    .ACC_Voucher_Trail_Detail_ForDelete({ VoucherId: row.VoucherId })
    .subscribe((res: any) => {
      // Assign the array of voucher headers (both deleted and original)
      this.voucherEditModel.Voucher = res.Item1;
      this.voucherEditModel.Voucher_Detail = res.Item2;

      // Sort headers by modification/creation date (optional, like edit trail)
       this.voucherEditModel.Voucher.sort((a, b) => {
          const parseDate = (dateStr) => {
            if (!dateStr) return 0;

            const [datePart, timePart] = dateStr.split(' ');
            const [day, month, year] = datePart.split('-');

            return new Date(`${year}-${month}-${day} ${timePart || '00:00:00'}`).getTime();
          };

          const dateA = parseDate(a.Voucher_ModifyOn || a.Voucher_CreateOn);
          const dateB = parseDate(b.Voucher_ModifyOn || b.Voucher_CreateOn);
        
          return dateA - dateB;
        });
    
      // For each voucher header, attach its corresponding details
      this.voucherEditModel.Voucher.forEach(header => {
        // Filter details that belong to this header (match by ID)
        const details = this.voucherEditModel.Voucher_Detail.filter(
          detail => detail.ID === header.ID
        );

        // Set AmountDR / AmountCR for display
        details.forEach(d => {
          d.AmountDR = 0.00;
          d.AmountCR = 0.00;
          if (d.TranType === 'CR') d.AmountCR = d.Amount;
          if (d.TranType === 'DR') d.AmountDR = d.Amount;
        });

        // Attach the details to the header
        header.Voucher_Detail = details;

        // Ensure Mode of Payment has a default value
        if (!header.Voucher_Mode_of_Payment) {
          header.Voucher_Mode_of_Payment = '';
        }
      });

      // Open the modal
      $('#VoucherEditDetail').modal('show');
      $("#VoucherEditDetail").css("z-index", "1050");
    });
}
    else {
     
      this.lmsService
        .ACC_Voucher_Trail_Detail({ VoucherId: row.VoucherId })
        .subscribe((res: any) => {
          //console.log("res", res);
          this.voucherEditModel.Voucher = res.Item1;
          this.voucherEditModel.Voucher_Detail = res.Item2;
         this.voucherEditModel.Voucher.sort((a, b) => {
          const parseDate = (dateStr) => {
            if (!dateStr) return 0;

            const [datePart, timePart] = dateStr.split(' ');
            const [day, month, year] = datePart.split('-');

            return new Date(`${year}-${month}-${day} ${timePart || '00:00:00'}`).getTime();
          };

          const dateA = parseDate(a.Voucher_ModifyOn || a.Voucher_CreateOn);
          const dateB = parseDate(b.Voucher_ModifyOn || b.Voucher_CreateOn);
        
          return dateA - dateB;
        });
          this.voucherEditModel.Voucher_Detail.forEach(x => {
            x.AmountDR = 0.00;
            x.AmountCR = 0.00;
            if (x.TranType == 'CR')
              x.AmountCR = x.Amount;
            if (x.TranType == 'DR')
              x.AmountDR = x.Amount;
          });
          this.voucherEditModel.Voucher.forEach(x => {
            if (x.Voucher_Mode_of_Payment == '' || x.Voucher_Mode_of_Payment == null)
              x.Voucher_Mode_of_Payment = '';
            x.Voucher_Detail = [];
x.Voucher_Detail = this.voucherEditModel.Voucher_Detail.filter(result => result.ID == x.ID);          });
          console.log(" this.voucherEditModel.Voucher", this.voucherEditModel.Voucher);
          $('#VoucherEditDetail').modal('show');
          $("#VoucherEditDetail").css("z-index", "1050");

          //if (this.voucherModel.Voucher.Voucher_Mode_of_Payment == '' || this.voucherModel.Voucher.Voucher_Mode_of_Payment == null)
          //  this.voucherModel.Voucher.Voucher_Mode_of_Payment = 'CASH';
          //this.onVoucherTagChange();
        });

    }
  }
calculateVoucherTotalDR(details: any[]): string {
  if (!details || details.length === 0) return '0.00';
  const sum = details.reduce((acc, row) => acc + (Number(row.AmountDR) || 0), 0);
  return sum.toFixed(2);
}

calculateVoucherTotalCR(details: any[]): string {
  if (!details || details.length === 0) return '0.00';
  const sum = details.reduce((acc, row) => acc + (Number(row.AmountCR) || 0), 0);
  return sum.toFixed(2);
}
  onVoucherTagChange() {
    //this.voucherModel.Voucher.Voucher_Mode_of_Payment = "";
    //this.voucherModel.Voucher.Voucher_E_Ref_No = "";
    //this.voucherModel.Voucher.Voucher_E_Transaction_Date = "";
    //this.voucherModel.Voucher.Voucher_Cheque_Clear_Date = "";
    //this.voucherModel.Voucher.Voucher_Bank_Name = "";
    //this.voucherModel.Voucher.Voucher_Cheque_Date = "";
    //this.voucherModel.Voucher.Voucher_Cheque_No = "";
    this.Get_Acc_Accounts_By_Tag();
  }
  Get_Acc_Accounts_By_Tag() {
    this.voucherModel.Voucher.DRAccountId = "";
    if (this.voucherModel.Voucher.Voucher_Tag == null)
      this.voucherModel.Voucher.Voucher_Tag = 'CASH';
    this.lmsService.Get_Acc_Accounts_By_Tag({ Account_Tag: this.voucherModel.Voucher.Voucher_Tag, Voucher_Date: new Date(this.voucherModel.Voucher.Voucher_Date) }).subscribe((res: any) => {
      this.accountTagDropdown = res;
    })
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }




  exportTable() : void {
    const uri = 'data:application/vnd.ms-excel;base64,';
    const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string => window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string => s.replace(/{(\w+)}/g, (m, p) => c[p]);
  
    const table = document.getElementById("voucher_trail") as HTMLTableElement;
    const worksheetName = 'VOUCHER TRAIL'; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");
  
    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));
  
    // Set the file name for the download
    downloadLink.download = worksheetName + ".xls";
  
    // Trigger the download
    downloadLink.click();
  }

  calculateTranTypeEditCR(Voucher_Detail) {
    if (Voucher_Detail != null) {
     
      let sum = 0.00;
      for (let i = 0; i < Voucher_Detail.length; i++) {
        sum += Number(Voucher_Detail[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateTranTypeEditDR(Voucher_Detail) {
    if (Voucher_Detail != null) {
      let sum = 0.00;
      for (let i = 0; i < Voucher_Detail.length; i++) {
        sum += Number(Voucher_Detail[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
}
